import { render, staticRenderFns } from "./SRadio.vue?vue&type=template&id=2b96204f"
import script from "./SRadio.vue?vue&type=script&lang=js"
export * from "./SRadio.vue?vue&type=script&lang=js"
import style0 from "./SRadio.vue?vue&type=style&index=0&id=2b96204f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports